<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">投訴類型設置-新增</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="100">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>類型名稱</span>
                                        </div>
                                        <RadioGroup v-model="form.type">
                                            <Radio :label="1">
                                                <span>投訴</span>
                                            </Radio>
                                            <Radio :label="2">
                                                <span>催單</span>
                                            </Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>文案內容</span>
                                        </div>
                                        <Input v-model="form.text" style="width:100"/>
                                    </FormItem>
                                </Col>
                            </Row>
                            
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>狀態</span>
                                        </div>
                                        <RadioGroup v-model="form.status">
                                            <Radio :label="2">
                                                <span>關閉</span>
                                            </Radio>
                                            <Radio :label="1">
                                                <span>開啟</span>
                                            </Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>排序</span>
                                        </div>
                                        <Input v-model="form.sort" style="width:100"/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">提交</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isSubmiting: false,
                form: {
                    type: '',
					text: '',
					status: '',
					sort: '',
                }
            };
        },
        methods: {
            handleBack() {
                this.$router.go(-1);
            },
            handleCheckForm() {
                let form = this.form;
                if(form.type == ''){
                    this.$Utils.showTipInfo('請選擇類型名稱');
                    return;
                }
                if(form.status == ''){
                    this.$Utils.showTipInfo('請選擇狀態');
                    return;
                }
                if(form.sort == ''){
                    this.$Utils.showTipInfo('請選擇排序');
                    return;
                }
                if(form.text == ''){
                    this.$Utils.showTipInfo('請選擇文案內容');
                    return;
                }
                this.handleSubmit();
            },
            handleSubmit() {
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.complaintManageListAdd,
                    method: 'post',
                    data: {
						status: form.status,
                        type: form.type,
                        text: form.text,
                        sort: form.sort,
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                        this.form = {
                           status: '',
                           type: '',
                           text: '',
                           sort: '',
                        };
                    } else {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "complaintManageAdd.scss";
</style>